import { FilterCountService } from './../../services/filter-count/filter-count.service';
import { FiltrosMagicos, FiltroMagico } from './../../../filtro-magico/interfaces/filtro-magico.interface';
import { ThFiltro } from './interfaces/th-filtro.interface';
import { SORT_DATA } from './../../constants/sort.constants';
import { DataTable, Sort, Columna } from './../../interfaces/datatable.interface';
import { Component, Input, OnInit, EventEmitter, Output } from '@angular/core';

@Component({
  selector: 'thead[app-datatable-th-lista]',
  templateUrl: './datatable-th-lista.component.html',
  styleUrls: ['./datatable-th-lista.component.scss']
})
export class DatatableThListaComponent implements OnInit {

  @Input() id: string;
  @Input() datatable: DataTable;

  @Output() onSortCambiados = new EventEmitter<Sort[]>();
  @Input() sorts: Sort[] = [];

  thFiltros: ThFiltro[] = [];
  filtrosModel = {};

  sortData;

  constructor(private filterCountService: FilterCountService) { 
    this.sortData = SORT_DATA;
  }

  ngOnInit(): void {
    this.datatable.columnas.forEach(c => {
      this.thFiltros.push({
        datatable: this.datatable,
        columna: c,
        filterKey: c.filterKey,
        class: '',
        filtrosMagicos: this.datatable.filtrosMagicos && c.filterKey ? 
          this.buildFiltroMagico(c) : 
          null
      });
    });
  }

  buildFiltroMagico(columna: Columna): FiltrosMagicos {
    const filtrosMagicos: FiltrosMagicos = {
      filtros: this.datatable.filtrosMagicos.filtros
        .filter(f => f.key === columna.filterKey)
        .map(f => {
          return {...f, mostrarLabel: false, class: this.getNewClass(f)};
        }),
      mostrarBotonFiltrar: false
    } ;
    return filtrosMagicos;
  }

  getNewClass(f: FiltroMagico): string {
    const classes = f.class.split(' ').filter(c => !c.startsWith('col-'));
    classes.push('col-md-12');
    const filterClass = classes.join(' ');
    return filterClass;
  }

  sortClickeado(col: Columna, clazz: string) {
    if (!col.sort) {
      return;
    }
    const index = this.sorts.findIndex(sort => sort.key === col.sortKey);
    if (clazz === SORT_DATA.CLASS_NONE && index !== -1) {
      this.sorts.splice(index, 1);
      this.sortCambiados();
    } else {
      const sort = clazz === SORT_DATA.CLASS_ASC ? SORT_DATA.ASC : SORT_DATA.DESC;
      if (index !== -1) {
        this.sorts[index].sort = sort;
        this.sortCambiados();
      } else if (this.puedeAgregarseUnSort()) {
          this.sorts.push({ key: col.sortKey, sort, columna: col });
          this.sortCambiados();
      } else if (!this.puedeAgregarseUnSort()) {
        this.sorts.shift();
        this.sorts.push({ key: col.sortKey, sort, columna: col });
        this.sortCambiados();
      }
    }
  }

  puedeAgregarseUnSort(): boolean {
    return !this.datatable.sortMaximos || this.datatable.sortMaximos > this.sorts.length;
  }

  getSortClass(col: Columna): string {
    const filtered = this.sorts.filter(s => s.key === col.sortKey);
    if (filtered.length === 0) {
      return SORT_DATA.CLASS_NONE;
    }
    return filtered[0].sort === SORT_DATA.ASC ? SORT_DATA.CLASS_ASC : SORT_DATA.CLASS_DESC;
  }

  hasToShow(col: Columna, clazz: string): boolean {
    const filtered = this.sorts.filter(s => s.key === col.sortKey);
    if (filtered.length === 0) {
      if (clazz === SORT_DATA.CLASS_ASC || clazz === SORT_DATA.CLASS_DESC) {
        return true;
      }
    } else {
      if (filtered[0].sort === SORT_DATA.ASC && clazz !== SORT_DATA.CLASS_ASC) {
        return true;
      } 
      if (filtered[0].sort === SORT_DATA.DESC && clazz !== SORT_DATA.CLASS_DESC) {
        return true;
      } 
    }
    return false;
  }

  sortCambiados() {
    this.onSortCambiados.emit(this.sorts);
  }

  isProductoFiltro(i: number) {
    if (this.thFiltros[i].filtrosMagicos) {
      return this.thFiltros[i].filtrosMagicos.filtros.some(x => x.tipo.startsWith('producto'))
    } 
    return false;
  }

  contarFiltros(i: number): number {
    return this.filterCountService.contarFiltros(this.filtrosModel[i] || {})
  }

  filtrosModelCambiado(i: number, filtros) {
    this.filtrosModel[i] = filtros;
  }

}
